<template>
    <div class="matrix-panel">
        <div class="container">
            <header>
                <h1>{{ __('Detail of the dietitian') }}</h1>
            </header>
            <div class="user-detail-boxes">
                <div class="user-detail-box-panel">
                    <div class="user-detail-box-info">
                        <div class="user-detail-box-header">
                            <figure><svg-icon icon="graph-up" /></figure>
                            <strong>{{ coach.count_patients_in_intensive_phase }}</strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('Intense Phase') }}</p>
                        </div>
                    </div>

                    <div class="user-detail-box-info">
                        <div class="user-detail-box-header">
                            <figure><svg-icon icon="graph-right" /></figure>
                            <strong>{{ coach.count_patients_in_sustain_phase }}</strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('Maintenance Phase') }}</p>
                        </div>
                    </div>

                    <div class="user-detail-box-info">
                        <div class="user-detail-box-header">
                            <strong>{{ coach.count_new_patients }}</strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('New in the last month') }}</p>
                        </div>
                    </div>
                </div>

                <div class="user-detail-box-panel">
                    <div class="user-detail-box-data">
                        <div class="user-detail-box-header">
                            <strong>
                                -
                            </strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('Response to messages') }}</p>
                        </div>
                    </div>

                    <div :class="'transparent-indicator-' + coach.consultation_rating_call_color" class="user-detail-box-data">
                        <div class="user-detail-box-header">
                            <strong :class="'indicator-' + coach.consultation_rating_call_color">
                                {{ coach.consultation_rating_call ? coach.consultation_rating_call+'%' : '-' }}
                            </strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('CSAT rating (call)') }}</p>
                        </div>
                    </div>

                    <div :class="'transparent-indicator-' + coach.consultation_rating_after_3_months_color" class="user-detail-box-data">
                        <div class="user-detail-box-header">
                            <strong :class="'indicator-' + coach.consultation_rating_after_3_months_color">
                                {{ coach.consultation_rating_after_3_months ? coach.consultation_rating_after_3_months+'%' : '-' }}
                            </strong>
                        </div>
                        <div class="user-detail-box-footer">
                            <p>{{ __('CSAT evaluation (3 months)') }}</p>
                        </div>
                    </div>
                </div>

                <!-- <div class="user-detail-box-panel">

          <div class="user-detail-box-data transparent-indicator-green">
              <div class="user-detail-box-header">
                <strong class="indicator-green">1 hod</strong>
              </div>
              <div class="user-detail-box-footer">
                <p>{{ __('Response to messages') }}</p>
              </div>
          </div>

          <div class="user-detail-box-data transparent-indicator-red">
            <div class="user-detail-box-header">
              <strong class="indicator-red">60%</strong>
            </div>
            <div class="user-detail-box-footer">
              <p>{{ __('CSAT rating (call)') }}</p>
            </div>
          </div>

          <div class="user-detail-box-data transparent-indicator-orange">
            <div class="user-detail-box-header">
              <strong class="indicator-orange">85%</strong>
            </div>
            <div class="user-detail-box-footer">
              <p>{{ __('CSAT evaluation (3 months)') }}</p>
            </div>
          </div>

        </div> -->
            </div>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        coach: {
            type: Object,
            required: true
        }
    }
}
</script>
